import { useCompare } from "@/contexts/CompareContext";
import { Button } from "@/components/ui/button";
import { X, GitCompareArrows } from "lucide-react";
import { useNavigate, useLocation } from "react-router-dom";

export const CompareBar = () => {
  const { items, remove, clear } = useCompare();
  const navigate = useNavigate();
  const location = useLocation();

  if (items.length === 0 || location.pathname === "/compare") return null;

  return (
    <div className="fixed bottom-0 left-0 right-0 z-50 bg-white border-t border-slate-200 shadow-[0_-4px_20px_rgba(0,0,0,0.1)] pb-safe" dir="rtl">
      <div className="container mx-auto px-4 md:px-6">

        {/* Mobile Layout */}
        <div className="md:hidden py-3 space-y-2.5">
          <div className="flex items-center justify-between">
            <span className="text-xs font-semibold text-slate-500">
              {items.length}/3 נבחרו להשוואה
            </span>
            <button onClick={clear} className="text-xs text-slate-400 hover:text-slate-600">
              נקה הכל
            </button>
          </div>

          <div className="flex items-center gap-2">
            {items.map((sys) => (
              <div
                key={sys.id}
                className="flex items-center gap-2 bg-slate-50 border border-slate-200 rounded-xl px-2.5 py-2 flex-1 min-w-0"
              >
                <img
                  src={sys.cover_image}
                  alt={sys.title}
                  className="w-8 h-8 rounded-lg object-cover shrink-0 border border-slate-100"
                />
                <span className="text-xs font-medium text-slate-800 truncate flex-1">
                  {sys.title}
                </span>
                <button
                  onClick={() => remove(sys.id)}
                  className="w-7 h-7 rounded-full bg-slate-200 hover:bg-red-100 hover:text-red-600 flex items-center justify-center text-slate-400 shrink-0 transition-colors"
                >
                  <X className="w-3.5 h-3.5" />
                </button>
              </div>
            ))}

            {items.length < 3 && (
              <div className="flex-1 min-w-0 border-2 border-dashed border-slate-200 rounded-xl h-[48px] flex items-center justify-center">
                <span className="text-xs text-slate-300 font-medium">+ הוסף</span>
              </div>
            )}
          </div>

          <Button
            onClick={() => navigate("/compare")}
            disabled={items.length < 2}
            className="w-full bg-slate-900 hover:bg-slate-800 text-white rounded-xl h-11 gap-2 text-sm font-semibold"
          >
            <GitCompareArrows className="w-4 h-4" />
            השווה {items.length} מערכות
          </Button>
        </div>

        {/* Desktop Layout */}
        <div className="hidden md:flex items-center gap-3 py-3">
          <div className="flex items-center gap-2 flex-1 overflow-x-auto no-scrollbar">
            {items.map((sys) => (
              <div
                key={sys.id}
                className="flex items-center gap-2 bg-slate-100 rounded-lg px-3 py-1.5 shrink-0"
              >
                <img
                  src={sys.cover_image}
                  alt={sys.title}
                  className="w-6 h-6 rounded object-cover"
                />
                <span className="text-sm font-medium text-slate-700 max-w-[120px] truncate">
                  {sys.title}
                </span>
                <button
                  onClick={() => remove(sys.id)}
                  className="text-slate-400 hover:text-slate-700 transition-colors"
                >
                  <X className="w-3.5 h-3.5" />
                </button>
              </div>
            ))}

            {items.length < 3 && (
              <div className="text-xs text-slate-400 shrink-0 px-2">
                {items.length === 1 ? "בחר עוד 1-2 להשוואה" : "בחר עוד 1 להשוואה (אופציונלי)"}
              </div>
            )}
          </div>

          <div className="flex items-center gap-2 shrink-0">
            <Button
              variant="ghost"
              size="sm"
              onClick={clear}
              className="text-slate-500 hover:text-slate-700 text-xs h-8 px-2"
            >
              נקה
            </Button>
            <Button
              size="sm"
              onClick={() => navigate("/compare")}
              disabled={items.length < 2}
              className="bg-slate-900 hover:bg-slate-800 text-white rounded-lg h-10 px-4 gap-2 text-sm font-medium"
            >
              <GitCompareArrows className="w-4 h-4" />
              השווה ({items.length})
            </Button>
          </div>
        </div>
      </div>
    </div>
  );
};
